export default __webpack_public_path__ + "static/media/wh_ep2_lead_2.2_02.02.060.db535ac5.png";